import { useTheme } from "@rentiohq/web-shared-next/dist/themes";
import { EFontWeights } from "@rentiohq/web-shared-next/dist/themes/types";

export const PaymentMethodOptionStyles = () => {
  const theme = useTheme();
  return {
    content: {
      label: {
        color: theme.palette.grey[600],
      },
      description: {
        fontWeight: EFontWeights.Regular,
      },
    },
  };
};
